import { Injectable } from '@angular/core';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService {
  private appInsights: ApplicationInsights;

  constructor(private router: Router) {
    const connectionString = environment.connectionString;
    const angularPlugin = new AngularPlugin();

    this.appInsights = new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: false,
        disableExceptionTracking: false,
        enableDebug: true,

        extensions: [angularPlugin],
        extensionConfig: {
          [angularPlugin.identifier]: { router: this.router }
        }
      }
    });

    if (connectionString?.includes('InstrumentationKey=')) {
      this.appInsights.loadAppInsights();
    }
  }

  trackEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name }, properties);
  }

  trackPageEvent(name?: string, event?: string, pageName?:string) {
    const emailId = localStorage.getItem('USERNAME');
    this.appInsights.trackEvent(
      { name: `${name}-${event}` },
      { user: emailId, event,pageName },
    );
    console.log(`Tracked Page Event: ${name}-${event} for user: ${emailId}`);
  }

 trackPageView(name?: string, url?: string, properties?: any) {
  this.appInsights.trackPageView({
    name,
    uri: url,
    properties: properties
  });
}


  trackMetric(metricName: string, value: number, properties?: any) {
    this.appInsights.trackMetric(
      { name: metricName, average: value },
      properties
    );
  }

  trackTrace(message: string, properties?: any) {
    this.appInsights.trackTrace({ message }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException(
      { exception, severityLevel }
    );
  }

  trackErrorEvent(eventName: string, param: any, statueCode: any, statusMessage: any, error: Error) {
    const props = {
      param,
      statueCode,
      statusMessage,
      message: error.message,
      stack: error.stack
    };

    this.appInsights.trackEvent(
      { name: eventName },
      props
    );
  }
}
